import {
  GraduationCap, Award, Users, Briefcase, TrendingUp, Network, Sparkles, Mail,
} from "lucide-react";
import AudiencePageShell from "../components/AudiencePageShell";
import SeoHead from "../components/SeoHead";

export default function PourLesUniversites() {
  return (
    <>
    <SeoHead
      title="Pour les universités · Rapprochez formation et emploi en Afrique"
      description="AFRICTAL relie universités, écoles et centres de formation africains à un écosystème d'employeurs, d'entrepreneurs et d'investisseurs pour valoriser les diplômés, tracer les parcours et bâtir les compétences de demain."
      path="/pour-les-universites"
      keywords="universités africaines, formation, insertion professionnelle, diplômés, certifications"
    />
    <AudiencePageShell
      testIdRoot="afr-audience-universites"
      breadcrumb={{ label: "Universités" }}
      eyebrow="Pour les universités et établissements"
      accentColor="var(--mod-formation)"
      heroTitle={<>Préparez les talents <em>de demain</em> avec AFRICTAL.</>}
      heroText={
        "AFRICTAL accompagne les universités, écoles et centres de formation dans la valorisation des compétences, l'insertion professionnelle des étudiants et le développement de partenariats avec les entreprises."
      }
      ctaPrimary={{ label: "Rejoindre AFRICTAL", to: "/login?mode=signup&role=universite", icon: GraduationCap }}
      ctaSecondary={{ label: "Découvrir les partenariats", to: "/solutions" }}

      servicesTitle="Les solutions pour les universités"
      servicesLead="Un environnement complet pour valoriser vos formations et accompagner vos étudiants."
      services={[
        { icon: GraduationCap, title: "Valoriser les formations",                     desc: "Présentez vos programmes et vos cohortes au sein d'un écosystème panafricain." },
        { icon: Award,         title: "Publier des certifications",                   desc: "Émettez des badges et certifications publics, vérifiables et reconnus." },
        { icon: Briefcase,     title: "Accompagner les étudiants vers l'emploi",       desc: "Un pont direct entre vos diplômés et les entreprises qui recrutent." },
        { icon: Network,       title: "Développer des partenariats avec les entreprises", desc: "Créez et pilotez des partenariats stratégiques avec les employeurs." },
        { icon: Users,         title: "Mettre en relation les diplômés avec les recruteurs", desc: "Un annuaire alumni intelligent et un matching entreprises/diplômés." },
        { icon: TrendingUp,    title: "Suivre l'insertion professionnelle",            desc: "Tableau de bord d'insertion pour mesurer l'impact de vos formations." },
      ]}

      stepsTitle="Comment ça fonctionne"
      steps={[
        "Créer un compte établissement",
        "Présenter vos formations et certifications",
        "Mettre en relation vos étudiants avec les entreprises",
        "Développer des partenariats",
        "Mesurer l'impact de vos formations",
      ]}

      whyTitle="Un trait d'union entre formation, entreprises et talents"
      whyText={
        "AFRICTAL rapproche les établissements de formation, les entreprises et les talents afin de faciliter l'insertion professionnelle, valoriser les compétences et répondre aux besoins du marché de l'emploi en Afrique. Chaque université y trouve un espace pour mettre en avant ses formations, ses diplômés et ses initiatives."
      }

      ctaFinalTitle="Ensemble, formons les talents qui construiront l'Afrique de demain."
      ctaFinalPrimary={{ label: "Rejoindre AFRICTAL", to: "/login?mode=signup&role=universite", icon: GraduationCap }}
      ctaFinalSecondary={{ label: "Nous contacter", to: "/a-propos" }}
    />
    </>
  );
}
